import { Navigate } from "@solidjs/router";
import { Match, type ParentComponent, Show, Switch } from "solid-js";
import { Loading } from "@/components/ui/loading";
import { useAuthV2 } from "../context/auth-provider";
import { getNextStepPath } from "../session/navigation";

/**
 * PublicRoute component that redirects authenticated users away from auth pages
 * (like login, signup) to prevent them from accessing these pages when already logged in
 */
export const PublicRoute: ParentComponent = (props) => {
  const [authStoreV2] = useAuthV2();

  return (
    <Show when={!authStoreV2?.loading} fallback={<Loading />}>
      <Switch>
        <Match when={authStoreV2?.profile?.id}>
          {/* User is authenticated, redirect to homepage or intended destination */}
          <Navigate href={getNextStepPath(authStoreV2?.next_step) ?? "/"} />
        </Match>
        <Match when={!authStoreV2?.profile?.id}>
          {/* User is not authenticated, allow access to auth pages */}
          {props.children}
        </Match>
      </Switch>
    </Show>
  );
};
